<template>
  <!-- A small corner card in the footer's look, not a wall: the page stays usable while it shows. Accept leads, but
       Reject is a real button of the same size beside it, as UK and EU rules want refusing to be as easy (GET-115). -->
  <section
    v-if="bannerVisible"
    aria-label="Cookie consent"
    class="fixed inset-x-4 bottom-4 z-(--z-overlay) rounded-2xl bg-dark-nav text-white shadow-lg sm:inset-x-auto sm:right-4 sm:w-[23rem]"
  >
    <div class="p-4">
      <div class="flex items-start gap-3">
        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/10 text-primary-lighter">
          <Cookie :size="18" aria-hidden="true" />
        </span>
        <p class="text-sm leading-relaxed text-white/80">
          We use cookies to improve Gettourly and measure our ads.
          <router-link to="/cookies" class="text-white underline underline-offset-2 hover:text-primary-lighter">
            Cookie policy
          </router-link>
        </p>
      </div>
      <div class="mt-4 grid grid-cols-2 gap-2">
        <!-- Accept on the left: the side nearer the page, where the cursor comes from. -->
        <button
          type="button"
          class="h-10 rounded-lg bg-primary text-sm font-semibold text-white transition-colors hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-lighter"
          @click="setConsent('accepted')"
        >Accept</button>
        <button
          type="button"
          class="h-10 rounded-lg border border-white/20 text-sm font-semibold text-white transition-colors hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/40"
          @click="setConsent('rejected')"
        >Reject</button>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { Cookie } from 'lucide-vue-next'
import { bannerVisible, setConsent } from '@/components/legal/consent'
</script>
